module.exports = __webpack_public_path__ + "static/img/bonfire.fcb865fc.svg";